import { createTheme, Theme, lighten, darken } from '@mui/material/styles';
const { isRabren } = require('../buildSettings.json');

export const smbTheme = createTheme({
  spacing: 16, // 1rem
  palette: {
    common: {
      black: '#000',
      white: '#fff'
    },
    //#1c6a37 // dark green
    // #13274b // dark blue
    // #333333 // dark grey
    primary: {
      light: lighten('#8bc640', 0.1),
      main: '#8bc640',
      dark: darken('#8bc640', 0.4),
      contrastText: '#fff'
    },
    secondary: {
      light: lighten('#13274b', 0.1),
      main: '#13274b',
      dark: darken('#13274b', 0.4),
      contrastText: '#fff'
    },
    tertiary: {
      light: lighten('#ffc107', 0.1),
      main: '#ffc107',
      dark: darken('#ffc107', 0.4),
      contrastText: '#000'
    },
    error: {
      main: '#A94442'
    },
    warning: {
      main: '#8A6D3B'
    },
    info: {
      main: '#31708F'
    },
    success: {
      main: '#3C763D'
    },
    background: {
      default: '#fff'
    },
    accent: {
      main: '#1c6a37'
    },
    typography: {
      tableHeaders: darken('#8bc640', 0.2), // primary
      labels: darken('#8bc640', 0.2) // primary // primary
    }
  }
});
export const rabrenTheme: Theme = createTheme({
  spacing: 16, // 1rem
  palette: {
    common: {
      black: '#000',
      white: '#fff'
    },
    //#1c6a37 // dark green
    // #13274b // dark blue
    // #333333 // dark grey
    primary: {
      light: lighten('#B91706', 0.1),
      main: '#B91706',
      dark: darken('#B91706', 0.4),
      contrastText: '#fff'
    },
    secondary: {
      light: lighten('#000000', 0.1),
      main: '#000000',
      dark: darken('#000000', 0.4),
      contrastText: '#fff'
    },
    error: {
      main: '#A94442'
    },
    warning: {
      main: '#8A6D3B'
    },
    info: {
      main: '#31708F'
    },
    success: {
      main: '#3C763D'
    },
    background: {
      default: '#fff'
    },
    accent: {
      main: '#000000'
    },
    typography: {
      tableHeaders: '#B91706', // primary
      labels: '#B91706' // primary
    }
  }
});
export const theme: Theme = isRabren === 'true' ? rabrenTheme : smbTheme;

theme.components = {
  MuiPaper: {
    defaultProps: {
      square: true,
      elevation: 1
    }
  },
  MuiAccordion: {
    defaultProps: {
      square: true
    }
  },
  MuiTextField: {
    defaultProps: {
      variant: 'outlined',
      autoComplete: 'off'
    }
  },
  MuiRadio: {
    defaultProps: {
      color: 'primary'
    }
  },
  MuiButton: {
    defaultProps: {
      disableElevation: true
    },
    styleOverrides: {
      root: {
        borderRadius: 0
      }
    }
  },
  MuiDialog: {
    styleOverrides: {
      root: {
        borderRadius: 0
      }
    }
  },
  MuiCard: {
    defaultProps: {
      variant: 'elevation'
    }
  },
  MuiAlert: {
    styleOverrides: {
      root: ({ ownerState }) => ({
        ...(ownerState.severity === 'error' && {
          backgroundColor: 'rgb(247, 203, 203)'
        })
      })
    }
  },
  MuiInputLabel: {
    styleOverrides: {
      outlined: {
        '&$shrink': {
          backgroundColor: theme.palette.common.white,
          paddingLeft: 3,
          paddingRight: 3,
          color: theme.palette.primary.main,

          '&$error': {
            color: theme.palette.error.main
          },
          '&$disabled': {
            opacity: 0.6
          }
        }
      }
    }
  },
  MuiFormLabel: {
    styleOverrides: {
      root: {
        '&$shrink': {
          color: theme.palette.primary.main,
          '&$focused': {
            color: theme.palette.error.main
          },
          '&$error': {
            color: theme.palette.error.main
          },
          '&$disabled': {
            opacity: 0.6
          }
        }
      }
    }
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        borderRadius: 0,
        color: theme.palette.common.black,
        '& fieldset': {
          borderColor: '#7e7e7e'
        },
        '&:hover fieldset': {
          borderColor: theme.palette.primary.main
        },
        '&$disabled': {
          '& input': {
            cursor: 'not-allowed',
            color: theme.palette.common.black
          },
          '& fieldset': {
            borderColor: '#b1b1b1'
          }
        },
        '@media print': {
          display: 'none'
        }
      }
    }
  },
  MuiTableCell: {
    styleOverrides: {
      head: {
        lineHeight: 1.25
      }
    }
  },
  MuiAppBar: {
    styleOverrides: {
      root: {
        '&&.tabBar': {
          backgroundColor: '#fff',
          boxShadow: 'none',
          borderBottom: `1px solid ${theme.palette.grey[400]}`,
          marginTop: '-1rem'
        }
      }
    }
  },
  MuiCssBaseline: {
    styleOverrides: {
      '@global': {
        'input[autocomplete="off"]::-webkit-contacts-auto-fill-button': {
          visibility: 'hidden',
          display: 'none !important',
          pointerEvents: 'none',
          position: 'absolute',
          right: 0
        },
        'label[data-shrink="true"]': {
          color: theme.palette.primary.main
        }
      }
    }
  }
};
